import React, { useState } from "react";
import { Trash2, Loader2 } from "lucide-react";

export default function DeleteAccountModal({ email, hasBusiness = false, onDelete, onCancel }) {
  const [typed, setTyped] = useState("");
  const [erase, setErase] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const ready = typed.trim().toUpperCase() === "DELETE";

  async function go() {
    if (!ready || busy) return;
    setBusy(true); setErr("");
    try { await onDelete({ eraseDevice: erase }); }
    catch (e) { setErr(e.message || "Couldn't delete the account."); setBusy(false); }
  }

  return (
    <div className="overlay-backdrop fixed inset-0 z-50 flex items-end lg:items-center justify-center" role="dialog" aria-modal="true" aria-label="Delete account">
      <div className="bg-card2 w-full max-w-md rounded-t-3xl lg:rounded-3xl p-6 max-h-[92vh] overflow-y-auto">
        <Trash2 size={20} style={{ color: "var(--rust)" }} className="mb-2" />
        <h3 className="v-display text-lg font-semibold">Delete your account?</h3>
        <p className="text-xs text-ivory-dim mt-1 leading-relaxed">This permanently deletes <span className="text-ivory">{email}</span> and everything stored online for it. It can't be undone.</p>
        <div className="text-xs mt-4 mb-1 font-semibold">Deleted for good</div>
        <ul className="text-xs text-ivory-dim list-disc pl-5 space-y-1 leading-relaxed">
          <li>Your login and the synced copy of your data.</li>
          {hasBusiness && <li>Invoices you shared by link (the links stop working) and your payment-setup link.</li>}
          <li>Your usage records, including AI allowance history.</li>
        </ul>
        <div className="text-xs mt-3 mb-1 font-semibold">Not affected</div>
        <ul className="text-xs text-ivory-dim list-disc pl-5 space-y-1 leading-relaxed">
          <li>The data on this device stays unless you tick the box below.</li>
          <li>If you pay for a plan through a payment provider, cancel that separately so you aren't charged.</li>
          {hasBusiness && <li>Your own Stripe account, if you connected one, stays yours. Close it in Stripe if you want it gone.</li>}
        </ul>
        <label className="flex items-start gap-2 text-xs mt-4 leading-relaxed"><input type="checkbox" checked={erase} onChange={(e) => setErase(e.target.checked)} className="mt-0.5" /> Also erase everything on this device</label>
        <div className="text-xs text-ivory-dim mt-4 mb-1">Type DELETE to confirm</div>
        <input value={typed} onChange={(e) => setTyped(e.target.value)} autoCapitalize="characters" autoComplete="off" className="w-full rounded-lg px-3 py-2.5 text-sm" />
        {err && <div className="text-xs mt-3" style={{ color: "var(--rust)" }}>{err}</div>}
        <div className="flex gap-2 mt-4">
          <button onClick={onCancel} className="flex-1 bg-card rounded-full py-2.5 text-sm font-medium">Keep my account</button>
          <button onClick={go} disabled={!ready || busy} className="flex-1 flex items-center justify-center gap-1.5 rounded-full py-2.5 text-sm font-semibold disabled:opacity-40" style={{ background: "var(--rust)", color: "#fff" }}>{busy ? <Loader2 size={14} className="animate-spin" /> : <Trash2 size={14} />} Delete</button>
        </div>
      </div>
    </div>
  );
}
